import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edusat',
  templateUrl: './edusat.component.html',
  styleUrls: ['./edusat.component.scss']
})
export class EdusatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
